import { BaseIcon, BaseIconProps } from './BaseIcon';

export const BarChart3Gradient: React.FC<BaseIconProps> = (props) => (
  <BaseIcon gradientId="barChart3Grad" {...props}>
    <path d="M3 3v18h18M18 17V9M13 17V5M8 17v-3" stroke="url(#barChart3Grad)" />
  </BaseIcon>
);
